"use client";

import { useRef } from "react";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP);
const bokehOrbs = [{
  top: "12%",
  left: "8%",
  size: 420,
  opacity: 0.28,
  blur: 90,
  delay: 0
}, {
  top: "18%",
  left: "68%",
  size: 520,
  opacity: 0.22,
  blur: 110,
  delay: 2
}, {
  top: "58%",
  left: "76%",
  size: 360,
  opacity: 0.3,
  blur: 80,
  delay: 4
}, {
  top: "62%",
  left: "12%",
  size: 480,
  opacity: 0.24,
  blur: 100,
  delay: 6
}, {
  top: "38%",
  left: "42%",
  size: 300,
  opacity: 0.18,
  blur: 70,
  delay: 3
}, {
  top: "82%",
  left: "48%",
  size: 380,
  opacity: 0.2,
  blur: 95,
  delay: 5
}];
export default function Casestudyhero() {
  const container = useRef<HTMLElement>(null);
  const prefersReducedMotion = useReducedMotion();
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.utils.toArray<HTMLElement>(".bokeh-orb").forEach((orb, i) => {
        gsap.to(orb, {
          x: `+=${(i % 2 === 0 ? 1 : -1) * 60}`,
          y: `+=${(i % 3 === 0 ? -1 : 1) * 40}`,
          duration: 60 + i * 4,
          ease: "sine.inOut",
          repeat: -1,
          yoyo: true
        });
      });
      gsap.to(".aurora-ring", {
        rotation: 360,
        duration: 240,
        ease: "none",
        repeat: -1,
        transformOrigin: "50% 50%"
      });
    });
  }, {
    scope: container
  });
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.09,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = prefersReducedMotion ? {
    hidden: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)"
    },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)"
    }
  } : {
    hidden: {
      opacity: 0,
      y: 24,
      filter: "blur(8px)"
    },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: {
        duration: 0.72,
        ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
      }
    }
  };
  return;
}